import Icon from '../components/Icon.vue';
Icon.register({
  'hat-cowboy-side': {
    width: 640,
    height: 512,
    paths: [{
      d: 'M260.8 291.1l98 84.5c78.2 67.4 130 104.5 233.2 104.5h-546.1c-14 0-27.1-7.5-35.9-20.6-9-13.5-12.1-30.7-8.6-47.3 20-93.3 85.6-156.1 163-156.1 34.4 0 67.8 12.1 96.4 35.1zM495.4 272.8c115 7.9 144.6 101.8 144.6 127.2 0 26.5-21.5 48-48 48-97.1 0-141.2-35.5-212.3-96.7l-98-84.5c-35.3-28.3-75.5-42.8-117.3-42.8-7.1 0-13.9 1.2-20.8 2l6.9-65.2c3-27.6 23.6-50.1 50.3-55.8l191.2-40.6c4.3-0.9 8.7-1.3 13.3-1.3 31.6 0 57.9 23 63.1 53.1z'
    }]
  }
});